import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-heightimage',
  templateUrl: './heightImage.component.html',
  styleUrls: ['../IconDesings.scss'],
})

export class HeightImageComponent {
  constructor() {
  }
}